import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

class Solutions {
  constructor(el) {
    this.el = el;
    this.init();
  }

  init() {
    //TODO improve animation and check why stagger isn't working well
    ScrollTrigger.batch('.solution', {
      start: 'top 75%',
      onEnter: (elements) => {
        gsap.to(elements, {
          stagger: 0.25,
          duration: 0.25,
          onComplete: () =>
            elements.forEach((el) => el.classList.add('active')),
        });
      },
    });

    ScrollTrigger.batch('.solution img', {
      start: 'top 75%',
      onEnter: (elements) => {
        gsap.to(elements, { opacity: 1, stagger: 0.27, duration: 0.25 });
      },
    });

    //TODO check with designer if the line should grow with window scrollTop
    // move this to a dif class
    ScrollTrigger.batch('.progress-line__line', {
      start: 'top 75%',
      onEnter: (elements) => {
        gsap.to(elements, { height: '100%', stagger: 0.27, duration: 0.25 });
      },
    });
  }
}

export default Solutions;
